import { Box, Typography } from "@mui/material";

export default function StickyFooter() {
  return (
    <footer className="footer container-fluid" style={{ textAlign: "center" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "#9da7b2",
            textAlign: "left",
            fontSize: "0.775rem",
          }}
        >
          {"© "}
          {new Date().getFullYear()}{" "}
          <a
            className="link"
            target="_blank"
            rel="noreferrer"
            href="https://theunplan.com/"
          >
            TheUnplan
          </a>
        </Typography>
        <Box className="footer-link" sx={{ display: "flex", gap: 2 }}>
          <a target="_blank" rel="noreferrer" href="https://theunplan.com/tnc">
            Terms
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://theunplan.com/privacy-policy"
          >
            Privacy
          </a>
        </Box>
      </Box>
    </footer>
  );
}
